import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/Rx';

import { MigalhasService } from 'app/shared/migalhas/migalhas.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';

import { Migalha } from 'models/migalha';
import { environment } from '../../environments/environment';

@Component({
  moduleId: module.id.toString(),
  selector: 'universidade',
  templateUrl: './universidade.component.html',
  styleUrls: ['./universidade.component.scss'],
  animations: [routerTransition],
})
export class UniversidadeComponent implements OnDestroy, OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  migalhas = [];
  url: BehaviorSubject<string>;
  environment = environment;

  baseMenuLateral = {
    nome: 'Estude no Grupo Ceuma',
    link: '/universidade',
  };

  menuLateral = [
    (environment.loginContexto!='CESUP') && (environment.loginContexto!=='CEUPI')?{
      nome: `Sobre ${environment.loginContexto=='CEUMA'?'a Universidade':'o Centro Universitário'}`,
      link: '/universidade/sobre',
    }:{
      nome: `sobre a faculdade`,
      link: '/universidade/sobre',
    },
    {
      nome: 'Formas de Ingresso',
      link: '/universidade/ingresso',
      submenu: [
        { nome: 'Vestibular', link: '/universidade/ingresso#vestibular', mostrarMobile: false },
        { nome: 'Enem', link: '/universidade/ingresso#enem', mostrarMobile: false },
        { nome: 'Transferência', link: '/universidade/ingresso#transferencia', mostrarMobile: false },
        { nome: 'Mat. para Graduados', link: '/universidade/ingresso#graduados', mostrarMobile: false },
        { nome: 'Reingresso', link: '/universidade/ingresso#reingresso', mostrarMobile: false },
      ],
    },
    {
      nome: 'Bolsas e Financiamentos',
      link: '/universidade/bolsas-financiamento',
      submenu: [
        { nome: 'ProUni', link: '/universidade/bolsas-financiamento#prouni', mostrarMobile: false },
        (environment.loginContexto!='EURO') ?
          { nome: 'Santander universidades', link: '/universidade/bolsas-financiamento#santander-universidades', mostrarMobile: false }:
          { nome: 'Financiamento Estudantil Pravaler', link: '/universidade/bolsas-financiamento#santander-universidades', mostrarMobile: false, submenu: 'frag' },
        { nome: 'FIES', link: '/universidade/bolsas-financiamento#fies', mostrarMobile: false },
        (environment.loginContexto!='FAMAZ'&&environment.loginContexto!='CEUMA'&&environment.loginContexto!='EURO')?
          { nome: 'Pravaler', link: 'https://www.pravaler.com.br/faculdades/unieuro/', mostrarMobile: false }:
          { nome: 'Financiamentos e Descontos', link: '/universidade/bolsas-financiamento#pronto', mostrarMobile: false},
      ],
    },
    {
      nome: 'Notícias',
      link: '/universidade/noticias',
      templateLink: /^\/universidade\/noticias(.*)/,
    },
    {
      nome: 'Grupo Ceuma',
      link: '/universidade/grupo-ceuma',
      templateLink: /^\/universidade\/grupo-ceuma(.*)/,
    },
    {
      nome: 'Corpo Dirigente',
      link: '/universidade/corpo-dirigente',
      templateLink: /^\/universidade\/corpo-dirigente(.*)/,
    },
    {
      nome: 'Egressos',
      link: environment.egressoPath!=undefined?environment.egressoPath:'#',
    },
    {
      nome: 'CPA',
      link: '/universidade/cpa',
    },
    (environment.loginContexto==='FAMAZ') && (environment.loginContexto==='FAMAZ')?{
      nome: 'EAD',
      link: 'https://ead.famaz.edu.br/',
    }:{
      nome: 'EAD',
      link: '/universidade/ead',
    },
    {
      nome: 'Núcleos Institucionais',
      link: '/universidade/nucleos',
    }
  ];

  obs;
  activeSegment;
  migalhasObs;

  constructor(
    private router: Router,
    private migalhasService: MigalhasService,
  ) {
    switch(environment.loginContexto){
      case "EURO":
        this.baseMenuLateral.nome = 'Estude no Unieuro';
        break;
      case "FAMAZ":
        this.baseMenuLateral.nome = 'Estude no Unifamaz';
        break;
      case "CEUPI":
        this.baseMenuLateral.nome = 'Estude no Ceupi';
        break;
      case "CESUP":
        this.baseMenuLateral.link = 'Estude no Cesup';
        break;
      case "CESUT":
        this.baseMenuLateral.link = 'Estude no Cesut';
        break;
    }
    const migalhaRaiz = new Migalha(this.baseMenuLateral);
    migalhaRaiz.submenu = Migalha.construirArray(this.menuLateral);

    this.migalhasObs = this.migalhasService
      .iniciar([migalhaRaiz])
      .subscribe((dados) => {
        this.migalhas = dados;
      });

    let url = '';
    this.obs = this.router.events.subscribe((evento) => {
      if (evento instanceof NavigationEnd) {
        url = evento.url;
        this.url.next(url);
        this.migalhasService.novaUrl(url);
      }
    });
    this.url = new BehaviorSubject<string>(url);
  }

  ngOnDestroy() {
    if (this.obs) {
      this.obs.unsubscribe();
    }

    if (this.migalhasObs) {
      this.migalhasObs.unsubscribe();
    }
  }

  ngOnInit() { }

  setActiveSegment(routes) {
    // deve conter no máximo 3 elementos nessa url, caso contrário o terceiro prevalecerá
    this.activeSegment = (routes.length > 3) ? routes[2] : routes[routes.length - 1];
  }

  isSegmentActive(menuItem) {
    if (menuItem.fragment) {
      return menuItem.fragment === this.activeSegment;
    }
    return menuItem.href === this.activeSegment;
  }
}
